import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiService {
  readonly BASE_URL = environment.apiURL;

  constructor(private http: HttpClient) { }

  // Obtener dispositivos
  public getDevices(): Observable<any> {
    return this.http.get<any>(this.BASE_URL +'/dispositivos');
  }

  // Obtener comandos
  public getCommands(): Observable<any> {
    return this.http.get<any>(this.BASE_URL +'/comandos');
  }

  // Ejecutar comando
  public executeCommand(data: any): Observable<any> {
    return this.http.put<any>(this.BASE_URL + '/ejecutar_comando', data);
  }
}
